(function () {
  var MOBILE_BREAKPOINT = 749;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  document.querySelectorAll('[data-concours-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var originalSlides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var viewport = carousel.querySelector('.concours-carousel__viewport');
    var total = originalSlides.length;
    var isDuo = total === 2;
    var isAnimating = false;

    if (total <= 1) return;

    // --- Mode duo desktop ---
    function initDuo() {
      if (isMobile()) {
        buildLoop();
      } else {
        clearLoop();
        track.style.transform = '';
        track.style.transition = '';
        originalSlides.forEach(function (s) {
          s.classList.add('is-active');
          initMiniSlider(s);
        });
      }
    }

    // --- Boucle infinie ---
    var allSlides = [];
    var current = 0;
    var cloneCount = 0;
    var loopBuilt = false;

    function buildLoop() {
      if (loopBuilt) {
        positionInstant(cloneCount);
        return;
      }

      cloneCount = total;
      var fragBefore = document.createDocumentFragment();
      var fragAfter = document.createDocumentFragment();

      originalSlides.forEach(function (slide) {
        var cb = slide.cloneNode(true);
        var ca = slide.cloneNode(true);
        [cb, ca].forEach(function (clone) {
          clone.classList.add('is-clone');
          clone.removeAttribute('data-carousel-slide');
          // Supprimer les mini-thumbs des clones
          var thumbs = clone.querySelector('[data-mini-thumbs]');
          if (thumbs) thumbs.remove();
          // Garder uniquement la première image visible dans le mini-slider
          var miniSlides = clone.querySelectorAll('.concours-slider__slide');
          miniSlides.forEach(function (ms, idx) {
            if (idx > 0) ms.remove();
            else ms.classList.add('is-active');
          });
        });
        fragBefore.appendChild(cb);
        fragAfter.appendChild(ca);
      });

      track.insertBefore(fragBefore, track.firstChild);
      track.appendChild(fragAfter);
      allSlides = Array.from(track.children);
      loopBuilt = true;

      // Positionner sans animation
      positionInstant(cloneCount);

      // Clic sur tous les slides (clones inclus)
      allSlides.forEach(function (slide, i) {
        slide.addEventListener('click', function () {
          if (isAnimating) return;
          if (isDuo && !isMobile()) return;
          if (i !== current) slideTo(i);
        });
      });
    }

    function clearLoop() {
      if (!loopBuilt) return;
      track.querySelectorAll('.is-clone').forEach(function (c) { c.remove(); });
      allSlides = Array.from(track.children);
      loopBuilt = false;
    }

    function getOffset(index) {
      var slide = allSlides[index];
      if (!slide) return 0;
      return slide.offsetLeft - (viewport.offsetWidth / 2) + (slide.offsetWidth / 2);
    }

    function positionInstant(index) {
      current = index;
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + (-getOffset(current)) + 'px)';
      track.offsetHeight; // force reflow
      updateActiveClasses();
    }

    function slideTo(index) {
      isAnimating = true;
      current = index;
      track.style.transition = 'transform 0.5s ease';
      track.style.transform = 'translateX(' + (-getOffset(current)) + 'px)';
      updateActiveClasses();
    }

    // --- Mini-slider autoplay ---
    var miniIntervals = {};

    var miniInitialized = {};

    function initMiniSlider(slideEl) {
      if (slideEl.classList.contains('is-clone')) return;

      var miniSlider = slideEl.querySelector('.concours-carousel__mini-slider');
      if (!miniSlider) return;
      var miniSlides = miniSlider.querySelectorAll('.concours-slider__slide');
      var miniThumbs = miniSlider.querySelectorAll('[data-mini-thumb]');
      if (miniSlides.length <= 1) return;

      var id = slideEl.getAttribute('data-carousel-slide');
      if (!id || miniInitialized[id]) return;
      miniInitialized[id] = true;

      var miniCurrent = 0;
      miniSlides.forEach(function (ms, idx) {
        if (ms.classList.contains('is-active')) miniCurrent = idx;
      });

      function goToMini(idx) {
        miniSlides[miniCurrent].classList.remove('is-active');
        if (miniThumbs[miniCurrent]) miniThumbs[miniCurrent].classList.remove('is-active');
        miniCurrent = ((idx % miniSlides.length) + miniSlides.length) % miniSlides.length;
        miniSlides[miniCurrent].classList.add('is-active');
        if (miniThumbs[miniCurrent]) miniThumbs[miniCurrent].classList.add('is-active');
      }

      miniThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function (e) {
          e.stopPropagation();
          var idx = parseInt(this.getAttribute('data-mini-thumb'), 10);
          goToMini(idx);
        });
      });
    }

    function updateActiveClasses() {
      var realIndex = ((current - cloneCount) % total + total) % total;

      allSlides.forEach(function (s, i) {
        var ri = ((i - cloneCount) % total + total) % total;
        s.classList.toggle('is-active', ri === realIndex);
      });

      // Init le mini-slider sur la vraie slide (au clic uniquement)
      var realSlide = originalSlides[realIndex];
      if (realSlide) initMiniSlider(realSlide);
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track) return;
      isAnimating = false;

      // Si on est sur un clone, repositionner instantanément sur le vrai
      if (current < cloneCount) {
        positionInstant(current + total);
      } else if (current >= cloneCount + total) {
        positionInstant(current - total);
      }
    });

    function init() {
      if (isDuo) {
        initDuo();
      } else {
        buildLoop();
      }
    }

    init();
    window.addEventListener('resize', function () { init(); });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (isAnimating) return;
        if (isDuo && !isMobile()) return;
        slideTo(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (isAnimating) return;
        if (isDuo && !isMobile()) return;
        slideTo(current + 1);
      });
    }
    // Scroll to concours section button
    var scrollBtn = carousel.querySelector('[data-carousel-scroll-top]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var concoursSection = carousel.closest('.concours');
        if (!concoursSection) return;

        var targetY = concoursSection.getBoundingClientRect().top + window.pageYOffset;
        var start = window.pageYOffset;
        var distance = targetY - start;
        var duration = 800;
        var startTime = null;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          var ease = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;
          window.scrollTo(0, start + distance * ease);
          if (progress < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
      });
    }
  });
})();
